<script>
    export let className;
    export let title;
    export let id;
</script>

<div
    class="flex py-16 px-8 sm:px-24 md:px-32 lg:px-48 xl:px-56 2xl:px-64 3xl:px-72 align-middle items-center {className}"
    {id}
>
    {#if !!title}
        <div class="w-full">
            <h2 class="text-5xl font-semibold mb-12">{title}</h2>
        </div>
    {/if}
    <slot />
</div>
